module.exports = __webpack_public_path__ + "img/CondimentTray.ccc3e1fb.jpg";